import {Injectable} from '@angular/core';
import {Observable, of, Subject} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {SnackBarService} from "../../../../@core/services/snack-bar.service";
import {catchError, switchMap, tap} from "rxjs/operators";
import {environment} from "../../../../../environments/environment";
import {UserService} from "../../../../@shared/services/user.service";
import {ICashBackHistory} from "./interfaces/cashback-history.interface";

@Injectable()
export class UserCashbackHistoryService {

  private readonly userCashbackHistoryRequest: Subject<any> = new Subject<any>();
  private readonly userCashbackHistory: Subject<ICashBackHistory> = new Subject<ICashBackHistory>();
  public readonly userCashbackHistory$: Observable<ICashBackHistory> = this.userCashbackHistory.asObservable();

  constructor(private readonly http: HttpClient,
              private readonly userService: UserService,
              private sb: SnackBarService) {
    this.subscribeEmitters();
  }

  public requestUserCashbackHistory(dateForm: { start: string, end: string }, pageSize: number, currentPage: number): void {
    this.userCashbackHistoryRequest.next({dateForm, pageSize, currentPage});
  }

  public resetCashback(comment: string): Observable<any> {
    return this.http.post(`${environment.GATEWAY_URL}/user/${this.userService.currentUserId.getValue()}/cashback-reset`, {comment})
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  private subscribeEmitters(): void {
    this.userCashbackHistoryRequest.pipe(
      switchMap((params) => this.http.get(`${environment.GATEWAY_URL}/user/cashback-history/${this.userService.currentUserId.getValue()}?startDate=${params.dateForm.start}&endDate=${params.dateForm.end}&page[size]=${params.pageSize}&page[number]=${params.currentPage + 1}`,
        {withCredentials: true})
        .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)))),
    ).subscribe((userCashbackHistory: any) => this.userCashbackHistory.next(userCashbackHistory));
  }

  private onHandleError(error: HttpErrorResponse): Observable<null> {
    const message = error.error.statusCode + ' ' + (error.error.message || error.error.error);
    this.sb.openSnackBar(message, 3000, 'error');
    return of(null);
  }
}

